import { render, staticRenderFns } from "./linked-external-ids-collapsible.vue?vue&type=template&id=4cdcdeb4"
import script from "./linked-external-ids-collapsible.ts?vue&type=script&lang=ts&external"
export * from "./linked-external-ids-collapsible.ts?vue&type=script&lang=ts&external"
import style0 from "./linked-external-ids-collapsible.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cdcdeb4')) {
      api.createRecord('4cdcdeb4', component.options)
    } else {
      api.reload('4cdcdeb4', component.options)
    }
    module.hot.accept("./linked-external-ids-collapsible.vue?vue&type=template&id=4cdcdeb4", function () {
      api.rerender('4cdcdeb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/linked-external-ids-collapsible/linked-external-ids-collapsible.vue"
export default component.exports